<template>
    <v-dialog v-model="model" :max-width="600">
        <v-card :loading="loading">

            <toolbar-page title="Configure features">
                <template v-slot:buttons>
                    <v-btn icon @click="loadFeatures">
                        <v-icon>mdi-reload</v-icon>
                    </v-btn>

                    <v-btn icon @click="closeClicked">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </template>
            </toolbar-page>

            <v-card-text class="mt-2">
                <v-alert type="info" class="body-2" prominent>
                    Configure features available for the tenant
                </v-alert>

                <v-checkbox v-for="feature in featuresToDisplay"
                            :key="feature.name"
                            v-model="feature.enabled"
                            :label="feature.displayName"
                            hide-details
                ></v-checkbox>

                <v-btn color="primary" class="mt-6" @click="saveFeatures" :loading="saving">Save changes</v-btn>

                <json v-if="false" :data="tenantFeatures[tenant.uuid]"/>

            </v-card-text>
        </v-card>
    </v-dialog>
</template>

<script>

import Json from 'vue-json-pretty';
import ToolbarPage from "../../../components/UI/ToolbarPage";
import {mapState, mapActions} from 'vuex';

const VuexModule = 'TenantManager';

export default {

    components: {
        ToolbarPage,
        Json
    },

    props: {
        value: {
            type: Boolean,
            required: true,
        },
        tenant: {
            type: Object,
            required: true,
        },
    },

    watch: {
        value(dialogOpen) {
            if (dialogOpen) {
                this.loadFeatures();
            }
        },

        tenant() {
            this.loadFeatures();
        }
    },

    computed: {

        ...mapState(VuexModule, [
            'tenantFeatures',
            'availableFeatures',
        ]),

        model: {
            get() {
                return this.value;
            },
            set(value) {
                this.$emit('input', value);
            }
        },

        settings() {
            return this.$store.state.settings;
        },

        currentFeatures() {
            return this.$store.state.settings.features;
        }
    },

    data() {
        return {
            loading: false,
            saving: false,
            featuresModel: [],
            featuresToDisplay: [],
        }
    },

    mounted() {
        if (this.value) {
            this.loadFeatures();
        }
    },

    methods: {
        ...mapActions(VuexModule, [
            'loadTenantFeatures',
            'saveTenantFeatures'
        ]),

        loadFeatures() {
            this.loading = true;
            this.loadTenantFeatures(this.tenant.uuid)
                .then(() => {
                    this.featuresToDisplay = this.availableFeatures.map(name => {
                        return {
                            displayName: this.ucFirst(name.replaceAll('_', ' ')),
                            name: name,
                            enabled: this.tenantFeatures[this.tenant.uuid].includes(name)
                        }
                    })
                })
                .catch(() => {
                    Bus.$emit('flash-message', {type: 'error', message: 'Feature flags failed ot load!'});
                })
                .finally(() => {
                    this.loading = false;
                })
        },

        saveFeatures() {
            this.saving = true;
            let features = this.featuresToDisplay.filter(feature => feature.enabled).map(feature => feature.name);

            const data = {
                uuid: this.tenant.uuid,
                features: features,
            };

            this.updateSettings();

            this.saveTenantFeatures(data)
                .then(() => {
                    Bus.$emit('flash-message', {type: 'success', message: 'Features saved!'});
                    this.closeClicked();
                })
                .catch(() => {
                    Bus.$emit('flash-message', {type: 'error', message: 'Feature flags failed ot save!'});
                })
                .finally(() => {
                    this.saving = false;
                })
        },

        updateSettings() {

            // Update only if modifying current tenant
            if (this.tenant.uuid === this.$store.state.PanelSettings.settings.uuid) {
                let settings = Object.assign({}, this.$store.state.settings);
                settings.features = this.featuresToDisplay.filter(feature => feature.enabled).map(feature => feature.name);
                this.$store.commit('setSettings', settings);
            }
        },

        closeClicked() {
            this.$emit('input', false);
        }
    }
}
</script>
